import { render } from "./DataOrganization.vue?vue&type=template&id=8a6bd974&scoped=true"
import script from "./DataOrganization.vue?vue&type=script&lang=js"
export * from "./DataOrganization.vue?vue&type=script&lang=js"

import "./DataOrganization.vue?vue&type=style&index=0&id=8a6bd974&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a6bd974"]])

export default __exports__